module.exports = __webpack_public_path__ + "img/Magnito-Client-Privilege-Program-3.0d165ab4.png";